import React, { PureComponent } from 'react'
import FieldWrapper from '../FieldRowWrapper'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import CustomizedSwitch from './materialToggle'
import Toggle from './Toggle'
import RawHtml from 'stories/components/RawHtml'

import './toggle-input.css'

export default class ToggleInput extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { hasFocus: false }
  }

  onInputChange = (event) => this.props.onChange(event.target.checked)

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => Boolean(this.props.value)

  toggleStyle = {
    style: { width: 'auto' },
    thumbStyle: { backgroundColor: 'grey' },
    thumbSwitchedStyle: {
      backgroundColor: this.props.color || 'darkslategrey',
    },
    trackSwitchedStyle: { backgroundColor: 'slategrey' },
  }

  shouldAddSuffixToTitleBasedOnToggleState = () =>
    Boolean(this.props.addSuffixBasedOnState)

  getSuffixBasedOnToggleState = () => {
    if (this.shouldAddSuffixToTitleBasedOnToggleState()) {
      const toggleState = this.getInputValue(),
        { suffixes = {} } = this.props
      return suffixes[toggleState ? 'active' : 'deActive'] || ''
    } else {
      return ''
    }
  }

  render() {
    const {
      label = '',
      name = '',
      required,
      touched,
      error,
      description,
      disabled,
      customized,
    } = this.props

    const classNames = {
      'formz-toggle-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
      'is-active': this.getInputValue(),
    }
    const inputProps = {
      name,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      disabled,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            {/* <div className="formz-input-title" /> */}
            <RawHtml
              className="formz-field-description"
              content={description}
            />
            <div className="formz-input-field formz-toggle-container">
              <div className="formz-toggle-inner-label">
                {label} {required && '(*)'} {this.getSuffixBasedOnToggleState()}
              </div>
              <Toggle
                name={name}
                toggled={this.getInputValue()}
                onToggle={this.onInputChange}
                {...this.toggleStyle}
              />
            </div>
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <CustomizedSwitch
          {...inputProps}
          label={label}
          checked={this.getInputValue()}
          onChange={this.onInputChange}
          error={Boolean(error)}
        />
      </FieldWrapper>
    )
  }
}
